<ng-container *ngIf="ttSlicerWidget">
    <tt-multi-select
        [ttData]="$any(data)"
        [ttPlaceholder]="$any(ttSlicerWidget).kpislicer_name"
        [ttDataId]="ttSlicerWidget.data_id"
        [ttDataName]="ttSlicerWidget.data_name"
        (ttSelect)="onSelectChanged($any($event))"
    ></tt-multi-select>
</ng-container>
